// src/App.js

import React from 'react';
import Board from './Board';

import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyCmosjC137E7NM4CFOt8nwkA2IY9O0th6w",
    authDomain: "sas-658cc.firebaseapp.com",
    databaseURL: "https://sas-658cc-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "sas-658cc",
    storageBucket: "sas-658cc.appspot.com",
    messagingSenderId: "701786775525",
    appId: "1:701786775525:web:44f2605b19c49bb147d90c",
    measurementId: "G-JLGSKLYWX2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

const App = () => {
    return (
        <div>
            <Board database={database} /> {/* Pass database as a prop */}
        </div>
    );
};

export default App;
